module.exports = __webpack_public_path__ + "components/country-flag/static/kn-dd0f31a85a12b7fb79e1868d68c34682.svg";